// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3n774","content":"LoadingAlert_content__2aKxN"};